/**
 * author:Bry
 * Data:2023-04-27 13:59
 * des:航油管理js
 */

import config from "@/config";
import http from "@/utils/request";

export default {
	aviationFuelList: {
		url: `${config.MAIN_URL}/maintenance/aviationFuelManage/aviationFuelList`,
		name: "航油管理分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	aviationFuelRepositoryList: {
		url: `${config.MAIN_URL}/maintenance/aviationFuelManage/aviationFuelRepositoryList`,
		name: "航油总览分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getStationNo: {
		url: `${config.MAIN_URL}/maintenance/aviationFuelManage/getStationNo`,
		name: "站点名称下拉列表",
		get: async function () {
			return await http.get(this.url);
		},
	},
	getOilTypeAndLeftAmount: {
		url: `${config.MAIN_URL}/maintenance/aviationFuelManage/getOilTypeAndLeftAmount`,
		name: "站点名称级联航油类型和剩余油量",
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},

	addAviationFuelRecord: {
		url: `${config.MAIN_URL}/maintenance/aviationFuelManage/addAviationFuelRecord`,
		name: '新增航油流水记录',
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},
	/* updatebrokenRecord: {
		url: `${config.MAIN_URL}/maintenance/breakdownManage/updatebrokenRecord`,
		name: "编辑故障记录",
		put: async function (data) {
			return await http.put(this.url, data);
		},
	},
	deletebrokenRecord: {
		url: `${config.MAIN_URL}/maintenance/breakdownManage/deletebrokenRecord`,
		name: "删除故障记录",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	}, */

};
